import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Users from '../Setup/Users/Users';
import Loader from '../Layout/Loader';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const UsersSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    loading,
    isAdminMode,
    getBackUrl,
  } = useSettingsCompany();

  if (loading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('navbar.users') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faUsers} />
          </span>
          {t('navbar.users')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <Users companyId={company?.id} />
    </div>
  );
};

export default UsersSettings;
